const selectors = {
    button: '[button-wishlist]',
    grid: '[grid-wishlist]',
    productCard: '.card-wrapper',
    wishListPageBtn: '.header__icon--wishlist'
  };

  
const initButtons = () => {
    const buttons = document.querySelectorAll(selectors.button) || [];
    if (buttons.length) {
      buttons.forEach(button => {
        const newButton = button.cloneNode(true);
        button.replaceWith(newButton);
      });
      const newButtons = document.querySelectorAll(selectors.button);
      setupButtons(newButtons);
    } else return;
    const event = new CustomEvent('shopify-wishlist:init-buttons', {
      detail: { wishlist: getWishlist() }
    });
    document.dispatchEvent(event);
  };